import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './AnchorPointItem.less';
import classNames from 'classnames';

AnchorPointItem.displayName = 'AnchorPointItem';

AnchorPointItem.propTypes = {
  skinTabs: PropTypes.array,
};

function AnchorPointItem(props) {
  const { skinTabs } = props;
  const [skin, setSkin] = useState(skinTabs[0]?.name);
  const [needFixed, setNeedFixed] = useState(false);
  const [isScroll, setIsScroll] = useState(false);

  const [height, setHeight] = useState();
  const ulRef = useRef();

  const calcIsNeedFixed = useCallback(() => {
    const tabs = document.getElementById('tabs');
    if (tabs) {
      const height = tabs.getBoundingClientRect().height;
      const top = tabs.parentElement.getBoundingClientRect().top;
      setHeight(height);
      setNeedFixed(top <= 0)
    }
  }, [needFixed]);

  useEffect(() => {
    calcIsNeedFixed();
    window.addEventListener('scroll', calcIsNeedFixed, true);
    return () => {
      window.removeEventListener('scroll', calcIsNeedFixed, true);
    }
  }, [calcIsNeedFixed]);

  useEffect(() => {
    if (ulRef.current.clientWidth < ulRef.current.scrollWidth) {
      setIsScroll(true);
    }
  }, [])

  return (
    <div className={styles.AnchorPointItemWrap} id="tabs"
      style={height && needFixed ? { height: height + 'px' } : undefined}
    >
      <div
        ref={ulRef}
        className={classNames(styles.AnchorPointList, {
          [styles.AnchorPointListFixed]: needFixed,
          [styles.longElement]: isScroll,
        })}
      >
        {skinTabs.map((item) => {
          return (
            <div
              key={item.name}
              className={classNames(styles.AnchorPointItem, {
                [styles.active]: item.name === skin,
              })}>
              <a href={'#' + item.name} onClick={() => setSkin(item.name)}>{item.name}</a>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default AnchorPointItem;
